import React from 'react';
import Grid from '@material-ui/core/Grid';
import useEntries from '../Common/useEntries';
import EventCard from '../Events/EventCard';
import { isNewsItem } from '../Events/eventFilters';
import {
    Section,
    SectionHeading,
    LoadingState,
    EmptyState,
} from '../Common/PageLayout';

/** Three most recent news items, shown on the homepage. */
export default function LatestNews() {
    const { items, loading } = useEntries({
        content_type: 'events',
        order: '-sys.createdAt',
        limit: 15,
    });

    const news = items.filter(isNewsItem).slice(0, 3);

    return (
        <Section tone="muted" bordered>
            <SectionHeading
                overline="Newsroom"
                title="Latest news"
                description="Announcements, press releases and updates from the Ministry of Finance."
                action={{ label: 'All news and press releases', to: '/latestnews' }}
                rule
            />

            {loading && <LoadingState label="Loading latest news" />}

            {!loading && news.length === 0 && (
                <EmptyState
                    title="No news available"
                    description="Published announcements will appear here."
                />
            )}

            {!loading && news.length > 0 && (
                <Grid container spacing={3}>
                    {news.map((event) => (
                        <Grid item xs={12} sm={6} md={4} key={event.sys.id}>
                            <EventCard event={event} />
                        </Grid>
                    ))}
                </Grid>
            )}
        </Section>
    );
}
